import React, { ReactElement, useEffect, useState, useRef } from 'react';

import * as z from 'zod';

import { useHirePlanForm } from '../../../../../contexts/HirePlanFormProviderGdf';
import { useHirePlanFormStepStore } from '../../../../../stores/useHirePlanFormStepStore';
import { dependentsSchema } from '../../../data/schema/dependentsSchema';

import { validateCEP } from '../../../../../utils/ValidateCEP';
import {
  changeCivilStatus,
  changeGender,
  changeUF,
  changeOrgao,
  changeParentageGDF,
  changePerfil,
  changeFontePagamento,
} from '../../../../../utils/ChangeArrays';
import { GoForwardButton } from '../../GoForwardButton';
import { DependentForm } from './DependentFormTeste';
import { Input } from '../../../../Input';
import { Select } from '../../../../Select';
import { useRouteLoaderData } from 'react-router-dom';
import { useBoostedPlanDataStore } from '../../../../../stores/useBoostedPlanDataStore';
import { usePlanLoadingStore } from '../../../../../stores/usePlanLoadingStore';
import {
  useDependentIdStore,
  useDependentOpenModalDataStore,
  useDependentValueStore,
} from '../../../../../stores/useDependentStore';
import { useVidaCountStore } from '../../../../../stores/useQuantidadeVidas';
import { getSiglaSeExistir } from '../../../../../utils/getSiglaIfExists';
import { fileSchema } from '../../../data/schema GDF/beneficiarySchema';
import { useLoadingStore } from '../../../../../stores/useLoadingStore';
import Loading from '../../../../icons/Loading';
import { CartIcon } from '../../../../icons/CartIcon';
import { PaymentSelector } from '../../../steps/PaymentMethodForm/PaymentSelector';
import { useCepValidator } from '../../../../../utils/useCepValidor';
import { isValidAbrange } from '../../../../../utils/ValidateAbrangencia';
import {
  getServidorOrgaoId,
  getServidorOrgaoNome,
} from '../../../../../utils/getServidorOrgaoId';

function validateDependent(obj: any): boolean {
  try {
    dependentsSchema.parse(obj);
    return true;
  } catch (error) {
    if (error instanceof z.ZodError) {
      return false;
    }
    return false;
  }
}

function normalizeText(value = ''): string {
  return value
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .toUpperCase()
    .trim();
}

interface FileErrors {
  Contracheque: string | null;
  Identidade: string | null;
}

export function BeneficiaryForm(): ReactElement {
  const ServidorData = useRouteLoaderData('token-servidor');
  const ServidorPaPData = useRouteLoaderData('token-servidorPaP');
  const data: any = ServidorData || ServidorPaPData;
  const { watch, setValue, errors, register, handleSubmit, onSubmit } =
    useHirePlanForm();
  const setBoostedPlanData = useBoostedPlanDataStore(
    state => state.setBoostPlanData,
  );
  const firstPaymentBillet = watch('payment.firstPaymentBillet');
  const Boostplan = useBoostedPlanDataStore(x => x.data);
  const valorDependentes = useDependentValueStore(x => x.setValorTotal);
  const [orgaos, setOrgaos] = useState([]);
  const [listOrgaos, setListOrgaos]: any = useState([]);
  const [isGdf, setIsGdf] = useState(false);
  const [isDnit, setIsDnit] = useState(false);
  const [isTjdft, setIsTjdft] = useState(false);
  const [isPrefPontGross, setIsPrefPontGross] = useState(false);
  const [isPartMac, setIsPartMac] = useState(false);
  const loading = useLoadingStore(state => state.loading);
  const setLoading = usePlanLoadingStore(state => state.setLoading);
  const [hasDependentes, setHasDependentes] = useState(false);
  const [awaiting, setAwaiting] = useState(isDnit || isGdf ? true : false);
  const countVida = useVidaCountStore(x => x.count);
  const setCountVida = useVidaCountStore(x => x.setVidaCount);
  const setId = useDependentIdStore(state => state.setId);
  const [depLib, setDepLib] = useState(false);
  const Parentesco = changeParentageGDF(data.listaParentescos);
  const { validarCep } = useCepValidator();

  const CEP = watch('user.address.cep');
  const dadosValidacao = watch('valida.validation.retorno');
  const city = watch('user.address.city');
  const neighborhood = watch('user.address.neighborhood');
  const street = watch('user.address.street');
  const plano = watch('user.plano');
  const dependentes = watch('user.dependents');
  const orgaoSelect = watch('user.orgao');
  const fontePagamento = watch('user.fontePagamento');

  const [orgaoInput, setOrgaoInput] = useState('');
  const [showOrgaoSuggestions, setShowOrgaoSuggestions] = useState(false);
  const orgaoRef = useRef<HTMLInputElement | null>(null);
  const orgaoRetornado = getServidorOrgaoId(dadosValidacao);
  const orgaoRetornadoNome = getServidorOrgaoNome(dadosValidacao);
  const [orgaoValidacaoFixado, setOrgaoValidacaoFixado] = useState(false);
  const orgaoBloqueado = isGdf && orgaoValidacaoFixado;

  useEffect(() => {
    if (orgaoSelect && listOrgaos && listOrgaos.length > 0) {
      const found = listOrgaos.find(
        (o: any) => String(o.Id) === String(orgaoSelect),
      );
      if (found) setOrgaoInput(found.Nome || '');
    }
    if (!Boostplan.token) {
      setBoostedPlanData(data);
    }
  }, [orgaoSelect, listOrgaos]);

  const Planos = [
    {
      Id: 993,
      Nome: 'OdontoClinico - apenas R$ 0,30 para o Titular',
      Tipo: 'OdontoClinico',
      separador: 1,
    },
    {
      Id: 998,
      Nome: 'OdontoDoc - apenas R$ 2,90 para o Titular',
      Tipo: 'OdontoDoc',
      separador: 1,
    },
    {
      Id: 999,
      Nome: 'OdontoProtese - apenas R$ 59,90 para o Titular',
      Tipo: 'OdontoProtese',
      separador: 1,
    },
    {
      Id: 1000,
      Nome: 'OdontoOrto - apenas R$ 80,00 para o Titular',
      Tipo: 'OdontoOrto',
      separador: 1,
    },
    {
      Id: 1008,
      Nome: 'OdontoClinico - apenas R$ 14,76 para o Titular',
      Tipo: 'OdontoClinico',
      separador: 2,
    },
    {
      Id: 1009,
      Nome: 'OdontoOrto - apenas R$ 42,95 para o Titular',
      Tipo: 'OdontoOrto',
      separador: 2,
    },
    {
      Id: 1010,
      Nome: 'OdontoProtese - apenas R$ 57,47 para o Titular',
      Tipo: 'OdontoProtese',
      separador: 2,
    },
    {
      Id: 1035,
      Nome: 'OdontoClinico - apenas R$ 15.90 para o Titular',
      Tipo: 'OdontoClinico',
      separador: 3,
    },
    {
      Id: 1036,
      Nome: 'OdontoOrto - apenas R$ 83.90 para o Titular',
      Tipo: 'OdontoOrto',
      separador: 3,
    },
    {
      Id: 1037,
      Nome: 'OdontoProtese - apenas R$ 69.90 para o Titular',
      Tipo: 'OdontoProtese',
      separador: 3,
    },
  ];
  const [fileErrors, setFileErrors] = useState<FileErrors>({
    Contracheque: null,
    Identidade: null,
  });

  const handleFileChange = (
    event: React.ChangeEvent<HTMLInputElement>,
    fileKey: number,
  ) => {
    const files = event.target.files;
    const result = fileSchema.safeParse({ file: files });
    if (result.success === false) {
      switch (fileKey) {
        case 1: {
          setFileErrors(prevErrors => ({
            ...prevErrors,
            Contracheque: result.error.issues[0].message,
          }));
          break;
        }
        case 2: {
          setFileErrors(prevErrors => ({
            ...prevErrors,
            Identidade: result.error.issues[0].message,
          }));
          break;
        }
      }
    } else {
      switch (fileKey) {
        case 1: {
          setFileErrors(prevErrors => ({
            ...prevErrors,
            Contracheque: null,
          }));
          setValue('user.Contracheque.file', files);
          break;
        }
        case 2: {
          setFileErrors(prevErrors => ({
            ...prevErrors,
            Identidade: null,
          }));
          setValue('user.Identidade.file', files);
          break;
        }
      }
    }
  };

  const TiposContratacao = [
    {
      Id: 1,
      Nome: 'Efetivo',
    },
    {
      Id: 2,
      Nome: 'Sem vínculo / Professor temporário',
    },
  ];

  const gdf = [993, 998, 999, 1000];
  const gdfDependentPlans = [994, 998, 999, 1000];
  const Dnit = [1035, 1036, 1037];
  const Tjdft = [1044, 1045, 1046];
  const PrefPontGross = [1054];
  const PartMac = [1055];
  useEffect(() => {
    const id = Number(data.produtoComercial.id_prodcomerc);

    setIsGdf(gdf.includes(id));
    setIsDnit(Dnit.includes(id));
    setIsTjdft(Tjdft.includes(id));
    setIsPrefPontGross(PrefPontGross.includes(id));
    setIsPartMac(PartMac.includes(id));
  }, [data]);

  const idCorretora = data.produtoComercial.corretora?.id_corretora;
  const planosFiltrados = Planos.filter(
    planoFiltrado =>
      planoFiltrado.separador === (isGdf ? 1 : isDnit ? 3 : 2) &&
      !(idCorretora == 0 && planoFiltrado.Id === 999),
  );

  useEffect(() => {
    if (dependentes && countVida > 1 && dependentes?.[0]?.name) {
      const Total = calcularDependenteVlTotal(dependentes || []);
      valorDependentes(Total);
      setHasDependentes(true);
    } else {
      setHasDependentes(false);
      valorDependentes(0);
    }
  }, [countVida]);
  const setDependentOpenModal = useDependentOpenModalDataStore(
    x => x.setdependentOpenModalData,
  );

  const getCEPDetails = async (e: string) => {
    const formatedCep = e.replace(/[^0-9]/g, '');
    if (formatedCep.length < 8) {
      return;
    }
    const CEPInformations = await fetch(
      `${process.env.REACT_APP_URL_BASE}/api/redeatendimento/Endereco?token=${process.env.REACT_APP_TOKEN_S4E_V2}&cep=${formatedCep}`,
      {
        method: 'POST',
      },
    ).then(response => response.json());

    setLoading(false);
    if (CEPInformations.dados == null) {
      alert('CEP não encontrado na Base');
    }
    const SiglaUf = getSiglaSeExistir(CEPInformations.dados.Uf);
    if (!SiglaUf) {
      alert('Não foi possível encontrar a UF correspondente ao CEP informado');
      setValue('user.address.cep', '');
      return;
    }
    const UF = data.listaUFS.find(x => x.sigla == SiglaUf).Id;
    const abrangeRegiao = isValidAbrange(
      data?.produtoComercial?.abrangeRegiao,
      String(UF),
    );
    if (!abrangeRegiao) {
      alert('Produto não abrange região informada no CEP');
      setValue('user.address.cep', '');
      return;
    }
    setValue('user.address.city', CEPInformations.dados.Municipio);
    setValue('user.address.neighborhood', CEPInformations.dados.Bairro);
    setValue('user.address.street', CEPInformations.dados.Logradouro);
    setValue('user.address.uf', String(UF));

    return CEPInformations;
  };

  const fetchOrgaoFP = async id => {
    const urlBaseApiV2 = process.env.REACT_APP_OG_API_URL;
    const response = await fetch(`${urlBaseApiV2}/info/orgaoFP?id=${id}`);
    if (!response.ok) {
      throw new Error(`HTTP error! Status: ${response.status}`);
    }
    const data = await response.json();
    if (data.length > 0) {
      changeOrgao(data);
      setOrgaos(data);
    }
  };

  const fetchPlan = async (planoId, VendedorId) => {
    const urlBaseApiV2 = process.env.REACT_APP_OG_API_URL;
    if (planoId && VendedorId) {
      setAwaiting(true);
      setLoading(true);
      const response = await fetch(`
        ${urlBaseApiV2}/info/getPlansSeller?vendedorId=${VendedorId}&produtoComercial=${planoId}`);

      if (!response.ok) {
        throw new Error(`HTTP error! Status: ${response.status}`);
      }
      const data = await response.json();
      const urlPlan = process.env.REACT_APP_OG_GET_PLAN_DETAILS_SERVER;
      const Plan = await fetch(`${urlPlan}${data.cd_Codtokenidparc}`);

      const retorno = await Plan.json();
      setBoostedPlanData(retorno);
      setLoading(false);
      setAwaiting(false);
    }
  };

  const hasInvalidGdfDependentPlan = () => {
    if (!isGdf) {
      return false;
    }

    return (dependentes || []).some(dependente => {
      const hasDependentData =
        dependente?.name || dependente?.cpf || dependente?.birthDate;

      return (
        hasDependentData &&
        !gdfDependentPlans.includes(Number(dependente?.plano))
      );
    });
  };

  async function handleValidate() {
    const contracheque = watch('user.Contracheque.file');
    const orgao = watch('user.orgao');
    const Cep = watch('user.address.cep');
    const tokenGdf = watch('payment.tokenGdf');
    const selectedPaymentType = watch('payment.Type');
    const erros: string[] = [];
    if (!Boostplan.token) {
      setBoostedPlanData(data);
    }
    if (isGdf || isDnit || isTjdft) {
      const matricula = watch('user.documents.matricula');
      if (!matricula || matricula.length < 3) {
        alert('Matrícula inválida. Verifique o número digitado.');
        return; // bloqueia o envio
      }
      if (!isTjdft) {
        const resultado = validarMatricula(matricula);
        if (!resultado.valido) {
          alert(resultado.mensagem);
          return; // bloqueia o envio
        }
      } else {
        if (contracheque) {
          // ToDo Validação do arquivo quando contratada a API do chatgpt
        }
      }
      if (isGdf) {
        if (!orgao || orgao == '' || orgao == '0') {
          erros.push('Órgão é obrigatório para GDF');
        }
      }
      if (isDnit) {
        setValue('user.orgao', '5');
        const payment = {
          Type: '2',
        };
        setValue('payment', payment);
      }
    }
    if (!contracheque && !isGdf && !isDnit && !isPrefPontGross) {
      erros.push('Contracheque é obrigatório para Servidores Públicos');
    }
    if (orgao && orgao == '114') {
      const identidade = watch('user.Identidade.file');
      if (!identidade) {
        erros.push('Identidade é obrigatório para a Defensoria Pública');
      }
    }
    if (!Cep) {
      alert('CEP é obrigatório');
      return;
    } else {
      const validateCep = await validarCep(Cep);
      if (!validateCep) {
        alert('CEP não encontrado ou inexistente');
        setValue('user.address.cep', '');
        setValue('user.address.city', '');
        setValue('user.address.neighborhood', '');
        setValue('user.address.street', '');
        setValue('user.address.uf', '');
        return;
      }
    }
    if (erros.length > 0) {
      alert(erros.join('\n'));
      return; // bloqueia o envio
    }
    if (
      Number(data.produtoComercial.id_prodcomerc) === 711 &&
      Number(selectedPaymentType) === 3 &&
      !tokenGdf?.trim()
    ) {
      alert('TOKEN GDF Ã© obrigatÃ³rio para a forma de pagamento GDF.');
      return;
    }
    if (hasInvalidGdfDependentPlan()) {
      alert('Plano do dependente é obrigatório para produtos GDF.');
      return;
    }
    if (dependentes && dependentes.length > 0) {
      dependentes.forEach((dep, index) => {
        if (!dep.name || dep.name.trim() === '') {
          removeClick(index);
        }
      });
    }
    handleSubmit(onSubmit)();
  }

  useEffect(() => {
    const dados = dadosValidacao;
    const matricula = watch('valida.matricula');
    const CPF = watch('valida.cpf');
    setValue('user.documents.cpf', CPF);
    setValue('user.documents.matricula', matricula);

    let matriculaNormalizada = matricula;
    if (matricula) {
      matriculaNormalizada = normalizeMatricula(matricula);
    }

    if (matriculaNormalizada !== matricula) {
      setValue('user.documents.matricula', matriculaNormalizada);
    }

    if (dados) {
      setValue('user.fullName', dados.nome || '');
      setValue('user.gender', dados.sexo == 'M' ? '2' : '1');
      setValue('user.birthDate', dados?.data_nasc || '');
      setValue('user.fullMothersName', dados?.nome_mae || '');
      setValue('user.email', dados?.email || '');
      setValue('user.phone', dados?.telefone || '');
      setValue('user.address.cep', dados?.cep || '');
      setValue('user.address.number', String(dados.numero) || '0');
      setValue('user.address.complement', dados.complemento || '');

      if (isGdf && orgaoRetornado) {
        setValue('user.orgao', orgaoRetornado);

        const orgaoEncontrado = listOrgaos.find(
          (orgao: any) => String(orgao.Id) === String(orgaoRetornado),
        );

        if (orgaoEncontrado) {
          setOrgaoInput(orgaoEncontrado.Nome || '');
          setOrgaoValidacaoFixado(true);
        } else {
          setOrgaoValidacaoFixado(false);
        }
      } else if (isGdf && orgaoRetornadoNome && listOrgaos.length > 0) {
        const normalizedOrgaoNome = normalizeText(orgaoRetornadoNome);
        const orgaoEncontrado = listOrgaos.find((orgao: any) => {
          const normalizedNome = normalizeText(orgao.Nome || '');

          return (
            normalizedNome === normalizedOrgaoNome ||
            normalizedNome.includes(normalizedOrgaoNome) ||
            normalizedOrgaoNome.includes(normalizedNome)
          );
        });

        if (orgaoEncontrado) {
          setValue('user.orgao', String(orgaoEncontrado.Id));
          setOrgaoInput(orgaoEncontrado.Nome);
          setOrgaoValidacaoFixado(true);
        } else {
          setOrgaoValidacaoFixado(false);
        }
      } else {
        setOrgaoValidacaoFixado(false);
      }

      if (dados.cep) {
        getCEPDetails(dados.cep);
      }
    }
  }, [dadosValidacao, isGdf, listOrgaos, orgaoRetornado, orgaoRetornadoNome]);

  useEffect(() => {
    if (CEP && validateCEP.test(CEP)) {
      getCEPDetails(CEP);
    }
  }, [CEP]);

  useEffect(() => {
    fetchPlan(plano, data.vendedorId);
  }, [plano]);

  useEffect(() => {
    const newOrgaos = changeOrgao(orgaos);
    setListOrgaos(newOrgaos);
  }, [orgaos]);

  useEffect(() => {
    if (orgaoSelect == '81') {
      setDepLib(false);
      setValue('user.dependents', []);
    } else {
      setDepLib(true);
    }
  }, [orgaoSelect]);

  const editClick = (index: number) => {
    setId(index);
    setDependentOpenModal(true);
  };

  useEffect(() => {
    fetchOrgaoFP(
      fontePagamento ? fontePagamento : isGdf ? 5 : isPrefPontGross ? 7 : 0,
    );
  }, [watch('user.fontePagamento'), isGdf, isPrefPontGross]);

  function calcularDependenteVlTotal(dependentes: any[]): number {
    return dependentes.reduce((total, dependente) => {
      const valor =
        parseFloat(dependente?.plano_vl?.replace(',', '.')) ||
        parseFloat(
          Boostplan
            ? Boostplan.produtoComercial.formasPagamentoIndividual[0].vl_valor
            : data.produtoComercial.formasPagamentoIndividual[0].vl_valor,
        );

      return total + (isNaN(valor) ? 0 : valor);
    }, 0);
  }

  const removeClick = (ind: number) => {
    const currentDependentes = watch('user.dependents') || [];
    const updatedDependentes = currentDependentes.filter(
      (_, index) => index !== ind,
    );
    if (updatedDependentes.length === 0) {
      setHasDependentes(false);
      valorDependentes(0);
      setCountVida(1);
    } else {
      const Total = calcularDependenteVlTotal(updatedDependentes);
      valorDependentes(Total);
      setCountVida(updatedDependentes.length + 1);
    }
    setValue('user.dependents', updatedDependentes);
  };

  changeUF(data.listaUFS);
  changeGender(data.listaSexos);
  changeCivilStatus(data.listaEstadosCivil);
  changePerfil(data.perfis);
  changeFontePagamento(data.fontePagamentos);
  function normalizeMatricula(matricula: string): string {
    return matricula.padStart(8, '0');
  }

  function validarMatricula(matricula: string): {
    valido: boolean;
    mensagem?: string;
  } {
    const matriculaNormalizada = normalizeMatricula(matricula);

    if (
      matriculaNormalizada.length === 8 &&
      matriculaNormalizada.startsWith('7')
    ) {
      return {
        valido: false,
        mensagem: 'Matrícula de professor temporário não pode realizar adesão.',
      };
    }

    return { valido: true };
  }

  return (
    <div className="w-full flex flex-col items-center">
      <h2 className="min-[748px]:text-xl text-lg font-semibold text-primary-main mb-4 mt-4">
        Dados do Titular
      </h2>
      <div className="w-full min-[748px]:mt-4 rounded-xl p-2">
        <div className="grid grid-cols-4 gap-6">
          <div className="col-span-2">
            <Input
              label="Nome"
              placeholder="Nome"
              errorMessage={errors.user?.fullName?.message}
              {...register('user.fullName')}
            />
          </div>
          <div className="col-span-1">
            <Input
              label="CPF"
              placeholder="CPF"
              activateMask
              mask="999.999.999-99"
              errorMessage={errors.user?.documents?.cpf?.message}
              {...register('user.documents.cpf')}
            />
          </div>
          <div className="col-span-1">
            <Input
              disabled={isGdf}
              label="Matrícula"
              placeholder="Matrícula"
              errorMessage={errors.user?.documents?.matricula?.message}
              {...register('user.documents.matricula')}
            />
          </div>
        </div>
        <div className="grid grid-cols-3 gap-6">
          <Select
            label="Sexo"
            options={[]}
            optionsFull={data.listaSexos}
            placeholder="Sexo"
            errorMessage={errors.user?.gender?.message}
            {...register('user.gender')}
          />
          <Select
            label="Estado civil"
            options={[]}
            optionsFull={data.listaEstadosCivil}
            placeholder="Estado civil"
            errorMessage={errors.user?.civilStatus?.message}
            {...register('user.civilStatus')}
          />
          <Input
            activateMask
            mask="99/99/9999"
            label="Data de nascimento"
            placeholder="Data de nascimento"
            errorMessage={errors.user?.birthDate?.message}
            {...register('user.birthDate')}
          />
        </div>
        <div className="grid grid-cols-4 gap-6">
          <div className="col-span-2">
            <Input
              label="Nome da mãe"
              placeholder="Nome da mãe"
              errorMessage={errors.user?.fullMothersName?.message}
              {...register('user.fullMothersName')}
            />
          </div>
          <div className="col-span-1">
            <Input
              label="E-mail"
              placeholder="E-mail"
              errorMessage={errors.user?.email?.message}
              {...register('user.email')}
            />
          </div>
          <div className="col-span-1">
            <Input
              label="Telefone"
              activateMask
              mask="(99) 99999-9999"
              placeholder="Telefone"
              errorMessage={errors.user?.phone?.message}
              {...register('user.phone')}
            />
          </div>
        </div>
        <div className="grid grid-cols-4 gap-6">
          <div className="col-span-1">
            <Input
              activateMask
              mask="99999-999"
              label="CEP"
              className="w-full"
              placeholder="CEP"
              errorMessage={errors.user?.address?.cep?.message}
              {...register('user.address.cep')}
            />
          </div>
          <div className="col-span-2">
            <Input
              label="Logradouro"
              value={street}
              placeholder="Digite o seu logradouro"
              errorMessage={errors.user?.address?.street?.message}
              {...register('user.address.street')}
            />
          </div>
          <Input
            label="Número"
            placeholder="Digite o seu número"
            errorMessage={errors.user?.address?.number?.message}
            {...register('user.address.number')}
          />
        </div>
        <div className="grid grid-cols-4 gap-6">
          <Input
            label="Complemento"
            placeholder="Digite o seu complemento"
            errorMessage={errors.user?.address?.complement?.message}
            {...register('user.address.complement')}
          />
          <Input
            label="Bairro"
            value={neighborhood}
            placeholder="Digite o seu bairro"
            errorMessage={errors.user?.address?.neighborhood?.message}
            {...register('user.address.neighborhood')}
          />
          <Input
            label="Cidade"
            value={city}
            placeholder="Digite sua cidade"
            errorMessage={errors.user?.address?.city?.message}
            {...register('user.address.city')}
          />
          <Select
            label="UF"
            options={[]}
            optionsFull={data.listaUFS}
            placeholder="UF"
            errorMessage={errors.user?.address?.uf?.message}
            {...register('user.address.uf')}
          />
        </div>
        {!isGdf && !isDnit && !isPrefPontGross && (
          <div className="grid grid-cols-6 gap-6">
            <div className="col-span-2">
              <Select
                label="Perfil"
                options={[]}
                optionsFull={data.perfis}
                placeholder="Perfil"
                errorMessage={errors.user?.perfil?.message}
                {...register('user.perfil')}
              />
            </div>
            <div className="col-span-2">
              <Select
                label="Fonte de Pagamento"
                options={[]}
                optionsFull={data.fontePagamentos}
                placeholder="Fonte de Pagamento"
                errorMessage={errors.user?.fontePagamento?.message}
                {...register('user.fontePagamento')}
              />
            </div>
            <div className="col-span-2">
              <Select
                label="Órgão"
                options={[]}
                optionsFull={listOrgaos}
                placeholder="Órgão"
                errorMessage={errors.user?.orgao?.message}
                {...register('user.orgao')}
              />
            </div>
          </div>
        )}
        {isGdf || isPrefPontGross ? (
          <>
            <div className="grid grid-cols-6 gap-6">
              <div className="col-span-2 relative">
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Órgão
                </label>
                <input
                  ref={orgaoRef}
                  type="text"
                  className="w-full border rounded px-3 py-2 focus:outline-none focus:ring-2 focus:ring-primary-main"
                  placeholder="Órgão"
                  value={orgaoInput}
                  disabled={orgaoBloqueado}
                  onChange={e => {
                    if (orgaoBloqueado) {
                      return;
                    }

                    setOrgaoInput(e.target.value);
                    setShowOrgaoSuggestions(true);
                  }}
                  onFocus={() => {
                    if (!orgaoBloqueado) {
                      setShowOrgaoSuggestions(true);
                    }
                  }}
                  onBlur={() =>
                    setTimeout(() => setShowOrgaoSuggestions(false), 150)
                  }
                />
                {errors.user?.orgao?.message && (
                  <span className="text-xs text-red-500">
                    {errors.user?.orgao?.message}
                  </span>
                )}
                {showOrgaoSuggestions && !orgaoBloqueado && listOrgaos && (
                  <ul className="absolute z-20 bg-white border rounded shadow max-h-40 overflow-y-auto w-full mt-1">
                    {listOrgaos
                      .filter((o: any) =>
                        orgaoInput
                          ? (o.Nome || '')
                              .toLowerCase()
                              .includes(orgaoInput.toLowerCase())
                          : true,
                      )
                      .map((orgao: any) => (
                        <li
                          key={orgao.Id}
                          className="px-4 py-2 hover:bg-gray-100 cursor-pointer"
                          onMouseDown={() => {
                            setOrgaoInput(orgao.Nome);
                            setValue('user.orgao', String(orgao.Id));
                            setShowOrgaoSuggestions(false);
                          }}
                        >
                          {orgao.Nome}
                        </li>
                      ))}
                  </ul>
                )}
              </div>
              <div className="col-span-2">
                <Input
                  label="Cargo"
                  placeholder="Digite seu Cargo"
                  errorMessage={errors.user?.cargo?.message}
                  {...register('user.cargo')}
                />
              </div>
              <div className="col-span-2">
                <Select
                  label="Tipo de contratação"
                  options={[]}
                  optionsFull={TiposContratacao}
                  placeholder="Contratação"
                  errorMessage={errors.user?.Contratacao?.message}
                  {...register('user.Contratacao')}
                />
              </div>
            </div>
            {!isPrefPontGross && (
              <div className="grid grid-cols-6 gap-6">
                <div className="col-span-2">
                  <Select
                    label="Órgão de Origem"
                    options={[]}
                    optionsFull={listOrgaos}
                    placeholder="Órgão de Origem"
                    errorMessage={errors.user?.lotacao?.message}
                    {...register('user.lotacao')}
                  />
                </div>
                <div className="col-span-1">
                  <Input
                    label="Matrícula Origem"
                    placeholder="Digite sua matrícula no Órgão de Origem"
                    errorMessage={errors.user?.matriculalotacao?.message}
                    {...register('user.matriculalotacao')}
                  />
                </div>
                {(isGdf || isDnit) && (
                  <div className="col-span-3">
                    <Select
                      disabled={hasDependentes && dependentes.length > 0}
                      label="Plano"
                      options={[]}
                      optionsFull={planosFiltrados}
                      placeholder="Plano"
                      errorMessage={errors.user?.plano?.message}
                      {...register('user.plano')}
                    />
                  </div>
                )}
              </div>
            )}
          </>
        ) : (
          <div className="grid grid-cols-6 gap-6">
            {(isGdf || isDnit) && (
              <div className="col-span-3">
                <Select
                  disabled={hasDependentes && dependentes.length > 0}
                  label="Plano"
                  options={[]}
                  optionsFull={planosFiltrados}
                  placeholder="Plano"
                  errorMessage={errors.user?.plano?.message}
                  {...register('user.plano')}
                />
              </div>
            )}
          </div>
        )}
        {!isGdf && !isPrefPontGross && (
          <div className="grid grid-cols-6 gap-6">
            <div className="col-span-3">
              <Input
                label="Contra-cheque:"
                type="file"
                errorMessage={fileErrors.Contracheque}
                onChange={e => handleFileChange(e, 1)}
              />
            </div>
            <div className="col-span-3">
              <Input
                label="Identidade:"
                type="file"
                errorMessage={fileErrors.Identidade}
                onChange={e => handleFileChange(e, 2)}
              />
            </div>
          </div>
        )}
      </div>
      {depLib && (
        <>
          <div
            className="w-full min-[748px]:mt-4 rounded-xl p-2"
            style={{
              marginTop: '20px',
              marginBottom: '20px',
              display: 'flex',
              flexDirection: 'row',
              gap: '40px',
              justifyContent: 'center',
              alignItems: 'center',
            }}
          >
            <h2 className="min-[748px]:text-[2rem] text-2xl font-semibold text-primary-main">
              Dependentes
            </h2>
            <p className="font-normal text-secondary-main mt-1">
              Você pode adicionar quantos dependentes desejar.
            </p>
            <DependentForm />
          </div>
          {!(isGdf || isDnit || isTjdft || isPrefPontGross) &&
            (data.produtoComercial.formasPagamentoIndividual?.length > 0 ||
              data.produtoComercial.formasPagamentoEmpresa?.length > 0) &&
            (data.produtoComercial.formasPagamentoIndividual?.find(
              x => x.cd_cod_contrato_s4_e,
            )?.cd_cod_contrato_s4_e !== 27855 ||
              data.produtoComercial.formasPagamentoEmpresa?.find(
                x => x.cd_cod_contrato_s4_e,
              )?.cd_cod_contrato_s4_e !== 27855) &&
            orgaoSelect && (
              <div className="flex flex-col items-center w-full mb-8">
                <div
                  className="w-full min-[748px]:mt-4 rounded-xl p-2"
                  style={{
                    marginTop: '20px',
                    marginBottom: '20px',
                    display: 'flex',
                    flexDirection: 'row',
                    gap: '40px',
                    justifyContent: 'space-evenly',
                    alignItems: 'center',
                  }}
                >
                  <h2 className="min-[748px]:text-[2rem] text-2xl font-semibold text-primary-main mb-4">
                    Forma de pagamento{' '}
                    {/* <span className="font-normal text-secondary-main mt-1 text-[1rem] ml-8">
                  Escolha uma forma de pagamento, para finalizar a compra.
                </span> */}
                  </h2>
                  <p className="font-normal text-secondary-main mt-1 mb-4">
                    Escolha uma forma de pagamento, para finalizar a compra.
                  </p>
                </div>
                <div className="flex flex-col items-center max-w-[755px] w-full">
                  <PaymentSelector />
                </div>
              </div>
            )}
        </>
      )}

      {hasDependentes && (
        <div className="w-full min-[748px]:mt-4 rounded-xl p-2">
          <table width="98%" style={{ margin: '2%' }}>
            <thead>
              <tr>
                <th style={{ textAlign: 'center' }}>Nome</th>
                <th style={{ textAlign: 'center' }}>CPF</th>
                <th style={{ textAlign: 'center' }}>Nascimento</th>
                <th style={{ textAlign: 'center' }}>Parentesco</th>
                <th style={{ textAlign: 'center' }}>Plano</th>
                <th style={{ textAlign: 'center' }}>Ações</th>
              </tr>
            </thead>
            <tbody>
              {dependentes?.map((dependente, index) => (
                <React.Fragment key={index}>
                  <tr>
                    <td style={{ textAlign: 'center' }}>{dependente.name}</td>
                    <td style={{ textAlign: 'center' }}>{dependente.cpf}</td>
                    <td style={{ textAlign: 'center' }}>
                      {dependente.birthDate}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      {dependente.parentage != ''
                        ? Parentesco.find(
                            x => x.Id == Number(dependente.parentage),
                          ).Sigla
                        : ''}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      {Planos.find(
                        x => x.Id == parseFloat(dependente.plano || '993'),
                      )?.Tipo || 'OdontoClinico'}
                    </td>
                    <td style={{ textAlign: 'center' }}>
                      <button type="button" onClick={() => editClick(index)}>
                        Editar
                      </button>
                      {' / '}
                      <button type="button" onClick={() => removeClick(index)}>
                        Remover
                      </button>
                    </td>
                  </tr>
                </React.Fragment>
              ))}
            </tbody>
          </table>
        </div>
      )}
      <GoForwardButton
        disabled={awaiting || loading}
        addBackButton
        Icon={loading ? Loading : CartIcon}
        desktopText={loading ? '' : 'Concluir Proposta'}
        mobileText={loading ? '' : 'Concluir Proposta'}
        onForwardClick={handleValidate}
      />
    </div>
  );
}
